var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1476 0H1.85235C1.05694 0 0.579897 0.883652 1.01631 1.54866L5.08605 7.75017C5.19301 7.91316 5.25 8.10387 5.25 8.29883V14.4038C5.25 15.1419 6.02215 15.6256 6.68627 15.3036L9.18627 14.0915C9.53105 13.9243 9.75 13.5749 9.75 13.1917V8.29883C9.75 8.10387 9.80699 7.91316 9.91395 7.75017L13.9837 1.54866C14.4201 0.88365 13.9431 0 13.1476 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.fae39d6c4a1a1c97332361802a8bea6a.svg";
export { ForwardRef as ReactComponent };